import { render, staticRenderFns } from "./NeighbourhoodTipsPanel.vue?vue&type=template&id=e73c30ac&scoped=true&"
import script from "./NeighbourhoodTipsPanel.vue?vue&type=script&lang=js&"
export * from "./NeighbourhoodTipsPanel.vue?vue&type=script&lang=js&"
import style0 from "./NeighbourhoodTipsPanel.vue?vue&type=style&index=0&id=e73c30ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73c30ac",
  null
  
)

export default component.exports